<script setup>

</script>

<template>
  <Button icon-class="fas fa-backspace" iconColor="#989EA7" btn-class="btn-sm" type="cancel" btn-text="button.back" @click="$router.go(-1)"/>
</template>

<script setup>
import Button from "../Button"
</script>
